window.showFormatter = function(value, row) {
    let html = '';
    if (value) {
        html += '<a href="'+value+'" class="btn btn-primary btn-sm w-100">';
        html += '<i class="fal fa-eye me-2"></i>';
        html += __('Details');
        html += '</a>';
    }
    return html;
}
